import { useEffect, useRef, useState } from 'react';

export function useMeasuredHeight(min = 200) {
  const ref = useRef(null);
  const [height, setHeight] = useState(min);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver(([entry]) => {
      setHeight(Math.max(min, Math.round(entry.contentRect.height)));
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [min]);

  return [ref, height];
}